export default {
  analytics: {
    segment: {
      writeKey:
        process.env.REACT_APP_SEGMENT_WRITE_KEY ||
        'EbfXGjeFn1paXEjL0Wie5jui5hggprwa',
    },
    logrocket: {
      apiKey: process.env.REACT_APP_LOGROCKET_API_KEY || 'wfndjr/dev-sy9pl',
    },
  },
  app: {
    development: process.env.NODE_ENV === 'development',
    name: 'hubble',
    url: process.env.PUBLIC_URL || '/',
  },
  auth: {
    google: {
      captchaSiteKey:
        process.env.REACT_APP_GOOGLE_CAPTCHA ||
        '6LcqarEUAAAAAD4MliCX7SmNKKPwIxRle4cpxLaR',
    },
  },
  calendly: {
    url: 'https://calendly.com/pronvest-service-center/retirement-consultation',
  },
  loggers: {
    sentry: {
      dsn:
        process.env.REACT_APP_SENTRY_DSN ||
        'https://1b577e1516184e7c8e98983d0601d642@o230777.ingest.sentry.io/1879673',
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'dev',
    },
  },
  moon: {
    url:
      process.env.REACT_APP_MOON_URL ||
      'https://staging.moon.futurecapital.com',
  },
  permissions: {
    andromedaComplianceAdminGroupId: '425c6919-2dc1-4d86-96d4-f47e106e7a3f',
    codeExchangeGroupId: '159fcf29-4cff-44ec-96cf-879a034418c8',
    andromedaAccessGroupId: '890a3281-a482-4535-85d2-e55a4d4da8d9',
    batchYodleeRelinkGroupId: '20ec96bb-30e3-48bf-9fa0-7a109034acab',
    integratedTransitionGroupId: '3bba7611-a48d-4dc2-ae23-50a4400e2430',
    fundReconciliationGroupId: 'f73eeb04-a47d-48fe-82a1-48f1c97b21e5',
  },
  pronvest: {
    api: {
      apiKey: '57ea68e8-abe1-49b9-8f4f-a326411312ec',
      url:
        process.env.REACT_APP_PRONVEST_API_URL || 'https://localhost:5001/v1/',
    },
    palms: {
      url:
        process.env.REACT_APP_PRONVEST_PALMS_URL || 'http://localhost:61905/',
    },
    planner: {
      url:
        process.env.REACT_APP_PRONVEST_PLANNER_URL || 'http://localhost:51065/',
    },
    signalR: {
      url:
        process.env.REACT_APP_SIGNALR_URL ||
        'https://localhost:5001/OutpostHub',
      speakeasyHubUrl:
        process.env.REACT_APP_SPEAKEASY_HUB_URL ||
        'https://localhost:5001/Hubs/Speakeasy',
      andromedaHubUrl:
        process.env.REACT_APP_ANDROMEDA_HUB_URL ||
        'https://localhost:5001/Hubs/Andromeda',
    },
    signup: {
      url:
        process.env.REACT_APP_PRONVEST_SIGNUP_URL ||
        'http://localhost:3000/launchpad/signup/',
    },
    sessionStorage: {
      prefix: 'Hubble_',
    },
  },
};
